import ReactDOM from "react-dom";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import CloseIcon from "assets/icons/close.svg?react";

import FilterIcon from "assets/icons/order/filter.svg?react";
import PackIcon from "assets/icons/order/pack.svg?react";
import CaseIcon from "assets/icons/order/case.svg?react";
import FileIcon from "assets/icons/order/file.svg?react";
import LetterIcon from "assets/icons/order/letter.svg?react";
import TagsIcon from "assets/icons/order/tags.svg?react";
import ActionsIcon from "assets/icons/order/actions.svg?react";
import TagWithBorder from "components/TagWithBorder";
import { useState } from "react";
import { useQuery } from "react-query";
import { axiosInstance } from "api/axios";
import { useTranslation } from "react-i18next";

const WideSearch: FC<Props> = ({ refWrapper, toggle }) => {
  const { t } = useTranslation();
  const [text, setText] = useState("");

  const [kind] = useState("1024");

  useQuery(
    ["wide-search", text, kind],
    async () => {
      const query = new URLSearchParams(window.location.search);

      query.append("Kind", kind);
      const res = await axiosInstance.get(`/list?${query}`);
      return res.data;
    }
  );

  const [types, setTypes] = useState({
    packages: false,
    cases: false,
    files: false,
    letters: false,
    tags: false,
    actions: false,
  });

  if (!refWrapper?.current) return <></>;

  const position = refWrapper.current.getBoundingClientRect();

  return ReactDOM.createPortal(
    <div
      style={{
        left: `${position.left}px`,
        top: `${position.top}px`,
        width: `${position.width}px`,
      }}
      className={styles.modal}
    >
      <div className={styles.inputWrapper}>
        <div className={styles.icon}>
          <FilterIcon />
        </div>
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          className={styles.input}
        />
        <div className={styles.close}>
          <CloseIcon
            onClick={() => {
              // setShowInput(true);
              //@ts-ignore
              // inputWrapper?.current?.focus?.();
              toggle();
            }}
          />
        </div>
      </div>

      <div className={styles.wrapper}>
        <div className={styles.box}>
          <div className={styles.title}>{t("wideSearch.searchingFor")}</div>
          <div className={styles.flex}>
            <TagWithBorder text={t("wideSearch.currentList")} onClick={() => {}} active />
            <TagWithBorder text={t("settings.all")} onClick={() => {}} />
          </div>
        </div>
        <div className={styles.box}>
          <div className={styles.title}>{t("wideSearch.searchingFor")}</div>
          <div className={styles.flex}>
            <TagWithBorder
              text={
                <div className={styles.element}>
                  <PackIcon />
                  {t("packages.title")}
                </div>
              }
              onClick={() => {
                setTypes({ ...types, packages: !types.packages });
              }}
              active={types.packages}
            />
            <TagWithBorder
              text={
                <div className={styles.element}>
                  <CaseIcon />
                  {t("sidebar.cases")}
                </div>
              }
              onClick={() => {
                setTypes({ ...types, cases: !types.cases });
              }}
              active={types.cases}
            />
            <TagWithBorder
              text={
                <div className={styles.element}>
                  <FileIcon />
                  {t("wideSearch.files")}
                </div>
              }
              active={types.files}
              onClick={() => {
                setTypes({ ...types, files: !types.files });
              }}
            />
            <TagWithBorder
              text={
                <div className={styles.element}>
                  <LetterIcon />
                  {t("wideSearch.letters")}
                </div>
              }
              onClick={() => {
                setTypes({ ...types, letters: !types.letters });
              }}
              active={types.letters}
            />
            <TagWithBorder
              text={
                <div className={styles.element}>
                  <TagsIcon />
                  #tag
                </div>
              }
              onClick={() => {
                setTypes({ ...types, tags: !types.tags });
              }}
              active={types.tags}
            />
            <TagWithBorder
              text={
                <div className={styles.element}>
                  <ActionsIcon />
                  {t("actions.title")}
                </div>
              }
              onClick={() => {
                setTypes({ ...types, actions: !types.actions });
              }}
              active={types.actions}
            />
          </div>
        </div>
        <div className={styles.box}>
          <div className={styles.title}>{t("wideSearch.searchResults")}</div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default WideSearch;
